// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"8aa79153","625":"715bad3b","949":"38b46e7c"}[chunkId] + ".chunk.js";
};